import React from 'react';
import parse from 'html-react-parser';

export default function OptionPrice({
  priceTitle = '',
  priceValueText = ''
}) {
  return priceValueText !== undefined && (
    <div className="app-option-price">
      {priceTitle && (<div className="app-option-price-label">{parse(priceTitle)}</div>)}
      <div className="app-option-price-value">
        {priceValueText && <span>{priceValueText}</span>}
      </div>
    </div>
  )
};
